import { Skeleton } from '@mui/material';
import { FC, ReactNode } from 'react';

import ShadowBox from '../ShadowBox/ShadowBox';
import classes from './ListBox.module.scss';

export interface ListBoxProps {
  loading?: boolean;
  itemsCount: number;
  title: string;
  emptyMessage: string;
  bottomNode?: ReactNode;
  children?: ReactNode;
}

const ListBox: FC<ListBoxProps> = ({
  loading = false,
  itemsCount,
  title,
  emptyMessage,
  bottomNode,
  children,
}) => {
  return (
    <ShadowBox className={classes.Container}>
      {!loading ? (
        <>
          <h5>{title}</h5>
          {itemsCount ? <ul>{children}</ul> : <p>{emptyMessage}</p>}
          {bottomNode}
        </>
      ) : (
        <div className={classes.Loading}>
          <Skeleton animation="wave" variant="text" />
          <Skeleton animation="wave" variant="rectangular" height={67} />
        </div>
      )}
    </ShadowBox>
  );
};

export default ListBox;
